import { Lightning as lng } from '@lightningjs/sdk';
import { MiniEpgCard } from './MiniEpgCard';

const _constants = {
  channelLocation: 478,
  channelsWidth: 410,
  cardWidth: 420,
  cardHeight: 327,
  height: 380,
  hSpacing: 28,
  amountLeft: 3,
  amountRight: 5,
  animationDuration: 0.1,
  spacingTop: 20,
};

const positionsLeft = [-_constants.cardWidth, _constants.hSpacing, _constants.cardWidth + _constants.hSpacing * 2];

const positionsRight = [
  -_constants.cardWidth,
  _constants.hSpacing,
  _constants.cardWidth + _constants.hSpacing * 2,
  _constants.cardWidth * 2 + _constants.hSpacing * 3,
  _constants.cardWidth * 3 + _constants.hSpacing * 4,
];

export class MiniEpgCardsContainer extends lng.Component {
  /**
   * @type {CardDataSource[]}
   */
  _cardsData = [];
  _noScheduleData = false;

  static _template() {
    return {
      w: w => w,
      h: h => h,
      CardsContainerLeft: {
        w: _constants.channelLocation,
        h: h => h,
        clipping: true,
        // rect: true,
        // color: 0xff00ff00,
      },
      CardsContainerRight: {
        x: _constants.channelLocation + _constants.channelsWidth,
        w: w => w - _constants.channelLocation - _constants.channelsWidth,
        h: h => h,
        clipping: true,
        // rect: true,
        // color: 0xff0000ff,
      },
    };
  }

  _init() {
    this._cardsContainerLeft = this.tag('CardsContainerLeft');
    positionsLeft.forEach(val => {
      this._cardsContainerLeft.childList.a({
        x: val,
        type: MiniEpgCard,
        w: _constants.cardWidth,
        h: _constants.cardHeight,
        y: _constants.spacingTop,
        visible: false,
      });
    });
    this._cardsContainerRight = this.tag('CardsContainerRight');
    positionsRight.forEach(val => {
      this._cardsContainerRight.childList.a({
        x: val,
        type: MiniEpgCard,
        w: _constants.cardWidth,
        h: _constants.cardHeight,
        y: _constants.spacingTop,
        visible: false,
      });
    });

    this._prevTime = 0;
    this._params = undefined;
  }

  moveLeft() {
    if (this._dataPosition < this._cardsData.length - 1) {
      const now = Date.now();
      if (now - this._prevTime > _constants.animationDuration * 1000) {
        this._prevTime = now;
        this._dataPosition += 1;
        this.moveLeftContainerLeft();
        this.moveRightContainerLeft();
      }
    }
  }

  moveRight() {
    if (this._dataPosition > 0) {
      const now = Date.now();
      if (now - this._prevTime > _constants.animationDuration * 1000) {
        this._prevTime = now;
        this._dataPosition -= 1;
        this.moveLeftContainerRight();
        this.moveRightContainerRight();
      }
    }
  }

  moveLeftContainerLeft() {
    this._cardsContainerLeft.children[1].setSmooth('x', positionsLeft[0], { duration: _constants.animationDuration });
    this._cardsContainerLeft.children[2].setSmooth('x', positionsLeft[1], { duration: _constants.animationDuration });

    /**
     * @type {MiniEpgCard}
     */
    const firstItem = this._cardsContainerLeft.childList.removeAt(0);
    firstItem.patch({
      x: positionsLeft[2],
    });
    this._cardsContainerLeft.childList.add(firstItem);
    // update first card
    firstItem.newData = this._cardsData[this._dataPosition];
    firstItem.visible = true;
  }

  moveLeftContainerRight() {
    this._cardsContainerLeft.children[0].setSmooth('x', positionsLeft[1], { duration: _constants.animationDuration });
    this._cardsContainerLeft.children[1].setSmooth('x', positionsLeft[2], { duration: _constants.animationDuration });
    /**
     * @type {MiniEpgCard}
     */
    const lastItem = this._cardsContainerLeft.childList.removeAt(this._cardsContainerLeft.childList.length - 1);
    lastItem.patch({
      x: positionsLeft[0],
    });
    this._cardsContainerLeft.childList.addAt(lastItem, 0);
    // update last card
    if (this._dataPosition - _constants.amountLeft + 1 >= 0) {
      lastItem.newData = this._cardsData[this._dataPosition - _constants.amountLeft + 1];
      lastItem.visible = true;
    } else {
      lastItem.visible = false;
    }
  }

  moveRightContainerLeft() {
    this._cardsContainerRight.children[1].setSmooth('x', positionsRight[0], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[2].setSmooth('x', positionsRight[1], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[3].setSmooth('x', positionsRight[2], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[4].setSmooth('x', positionsRight[3], { duration: _constants.animationDuration });

    /**
     * @type {MiniEpgCard}
     */
    const firstItem = this._cardsContainerRight.childList.removeAt(0);
    firstItem.patch({
      x: positionsRight[4],
    });
    this._cardsContainerRight.childList.add(firstItem);
    // update first card
    const data = this._cardsData[this._dataPosition + _constants.amountRight - 2];
    if (data) {
      firstItem.newData = data;
      firstItem.visible = true;
    } else {
      firstItem.visible = false;
    }
  }

  moveRightContainerRight() {
    this._cardsContainerRight.children[0].setSmooth('x', positionsRight[1], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[1].setSmooth('x', positionsRight[2], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[2].setSmooth('x', positionsRight[3], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[3].setSmooth('x', positionsRight[4], { duration: _constants.animationDuration });
    this._cardsContainerRight.children[4].x = positionsRight[0];

    /**
     * @type {MiniEpgCard}
     */
    const lastItem = this._cardsContainerRight.childList.removeAt(this._cardsContainerRight.childList.length - 1);
    this._cardsContainerRight.childList.addAt(lastItem, 0);
    // update last card
    if (this._dataPosition > 0) {
      lastItem.newData = this._cardsData[this._dataPosition - 1];
      lastItem.visible = true;
    } else {
      lastItem.visible = false;
    }
  }

  _getFocused() {
    if (this._noScheduleData) return this;
    return this._cardsContainerRight.children[1];
  }

  set catalogID(id) {
    this._catalogID = id;
  }

  /**
   * @param {CardDataSource[]} data
   */
  set schedules(data) {
    // const compareArrays = (a, b) => a.length === b.length && a.every((element, index) => element === b[index]);
    // if (compareArrays(this._cardsData, data)) { // this comparison doesnt work
    //   // no need to update data
    // } else {
    this._cardsData = data;
    this.updateData();
    // }
  }

  updateData() {
    this._dataPosition = 0;
    this._noScheduleData = this._cardsData.length <= 0;
    // find current schedule position
    const itemsInPast = this._cardsData.filter(cardData => cardData.asset.asset.published.end * 1000 < Date.now());
    this._dataPosition = itemsInPast.length;
    // console.log('past items', itemsInPast, this._cardsData);
    // update left
    this.initialLeft();
    // update right
    this.initialRight();
    this._refocus();
  }

  initialLeft() {
    this._cardsContainerLeft.children.forEach(child => (child.visible = false));
    let vals = [];
    if (this._dataPosition - _constants.amountLeft - 1 >= 0) {
      vals = this._cardsData.slice(this._dataPosition - _constants.amountLeft + 1, this._dataPosition + 1);
    } else {
      vals = this._cardsData.slice(0, this._dataPosition + 1);
      const length = vals.length;
      for (let i = 0; i < _constants.amountLeft - length; i++) {
        vals = [undefined].concat(vals);
      }
    }
    // console.log('cards for left', vals);
    vals.forEach((val, i) => {
      if (val) {
        this._cardsContainerLeft.children[i].newData = val;
        this._cardsContainerLeft.children[i].visible = true;
      }
    });
  }

  initialRight() {
    this._cardsContainerRight.children.forEach(child => (child.visible = false));
    let vals = [];
    if (this._dataPosition === 0) {
      vals = [undefined].concat(
        this._cardsData.slice(this._dataPosition, this._dataPosition + _constants.amountRight - 1)
      );
    } else {
      if (this._dataPosition + _constants.amountRight - 1 <= this._cardsData.length) {
        vals = this._cardsData.slice(this._dataPosition - 1, this._dataPosition + _constants.amountRight - 1);
      } else {
        vals = this._cardsData.slice(this._dataPosition - 1);
        const length = vals.length;
        for (let i = 0; i < _constants.amountRight - length; i++) {
          vals = vals.concat([undefined]);
        }
      }
    }
    // console.log('cards for right', vals);
    vals.forEach((val, i) => {
      if (val) {
        this._cardsContainerRight.children[i].newData = val;
        this._cardsContainerRight.children[i].visible = true;
      } else {
        this._cardsContainerRight.children[i].visible = false;
      }
    });
  }

  clearImages() {
    this._cardsContainerLeft.children.forEach(card => {
      card.clearImage();
    });
    this._cardsContainerRight.children.forEach(card => {
      card.clearImage();
    });
  }
}
